module.exports = __webpack_public_path__ + "img/hmi-cross.cbc1d340.png";